import { Card } from '@/components/common/layout/card';
import { Skeleton } from '@/components/common/feedback/skeleton/skeleton';
import React from 'react';

export const LoadingSkeleton = () => {
  return (
    <Card className='relative rounded-xl bg-card p-4 shadow-md'>
      <div className='flex items-start justify-between gap-6'>
        <div className='flex items-start gap-6'>
          <Skeleton className='h-24 w-24 rounded-full' />
          <div className='flex-1 space-y-2'>
            <Skeleton className='h-4 w-24' />
            <Skeleton className='h-10 w-full' />
            <div className='flex gap-2'>
              {[1, 2, 3].map((i) => (
                <Skeleton key={i} className='h-12 flex-1 rounded-lg' />
              ))}
            </div>
          </div>
        </div>
        <Skeleton className='h-8 w-8 rounded-lg' />
      </div>
    </Card>
  );
}; 